import { Component } from '@angular/core'

@Component({
  selector: 'ftr-confirmation-sent-page',
  template: '<ftr-confirmation-sent></ftr-confirmation-sent>',
  standalone: false,
})
export class ConfirmationSentPage {}
